// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".block--title .title{margin-bottom:0}@media (min-width:48.0625em){.block--title.row-auto{padding:0 calc(var(--spacing)*3);text-align:left}.block--title.row-auto .slice__inner{justify-content:flex-start}.block--title.row-auto .portable-text{margin:0}}@media (max-width:48.0525em){.blocks--gallery .block--title{text-align:left}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
